/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const MultipleSearchCriteria = (props) => {

    const [values, setValues] = useState([]);
    const elementRef = useRef();

    useEffect(() => {

        let data = [];
        if (props.label === 'PIN') {

            data = props.pinPlateDetails.pins.split(',');

        } else if (props.label === 'DEALER_ACCOUNT') {

            data = props.pinPlateDetails.dealerAccounts.split(',');

        } else if (props.label === 'STATUS') {

            data = props.pinPlateDetails.status.split(',');

        } else if (props.label === 'TCSM_ID') {

            data = props.pinPlateDetails.requesterTCSMs.split(',');

        } else if (props.label === 'FACTORY') {

            data = props.pinPlateDetails.factoryCodes.split(',');

        } else if (props.label === 'CREATED_DATE_FROM') {

            // Expecting createdDate in "from,to" format
            data = props.pinPlateDetails.fromDateSubmmited ? props.pinPlateDetails.fromDateSubmmited.split(',') : [];

        } else if (props.label === 'CREATED_DATE_TO') {

            data = props.pinPlateDetails.toDateSubmmited ? props.pinPlateDetails.toDateSubmmited.split(',') : [];

        } else if (props.label === 'UPDATED_DATE_FROM') {

            // Expecting updatedDate in "from,to" format
            data = props.pinPlateDetails.fromUpdatedTs ? props.pinPlateDetails.fromUpdatedTs.split(',') : [];

        } else if (props.label === 'UPDATED_DATE_TO') {

            // Expecting updatedDate in "from,to" format
            data = props.pinPlateDetails.toUpdatedTs ? props.pinPlateDetails.toUpdatedTs.split(',') : [];

        }

        if (data[0] === '') {

            setValues([]);

        } else {

            setValues([...data]);

        }

    }, [props.pinPlateDetails.pins, props.pinPlateDetails.dealerAccounts, props.pinPlateDetails.fromDateSubmmited, props.pinPlateDetails.toDateSubmmited, props.pinPlateDetails.fromUpdatedTs, props.pinPlateDetails.toUpdatedTs, props.pinPlateDetails.requesterTCSMs, props.pinPlateDetails.factoryCodes, props.label, props.pinPlateDetails.status]);

    const handleChange = (i, event) => {

        const value = [...values];
        value[i] = event.target.value;
        setValues(value);

    };

    const addClick = (event) => {

        const data = event.target == null ? '' : event.target.value;
        setValues((prevState) => [...prevState, data]);
        event.target.value = '';

    };

    const handlePaste = (event) => {

        const text = event.clipboardData.getData('Text');
        event.preventDefault();
        let data = text.split(/\n|[',']/);
        data = data.map((x) => x.trim());
        setValues((prevValues) => [...prevValues, ...data]);

    };

    return (

        <div className="multiple-users-dealers">
            <div className="users-dealers-headers">
                <div id="invisiblediv" />
                <div><FormattedMessage id={props.label} /></div>
                <span
                    className="icon-close-small"
                    onClick={props.onClose}
                />
            </div>
            <div className="users-dealers-body">
                {
                    values.map((el, i) => el !== '\r' && el !== '' && (
                        <input
                            key={el}
                            type="text"
                            value={el || ''}
                            onPaste={handlePaste}
                            onChange={(event) => handleChange(i, event)}
                        />
                    ))
                }
                <input type="text" ref={elementRef} placeholder="Paste Here" onPaste={handlePaste} onBlur={(event) => addClick(event)} />
            </div>
            <div className="users-dealers-footer">
                <button
                    type="button"
                    onClick={() => {

                        setValues([]); props.handleSubmit(props.label, '');

                    }}
                >
Clear
                </button>
                <button type="button" id="save" onClick={() => props.handleSubmit(props.label, values.filter((x) => x !== '\r' && x !== '').join(','))}>Save</button>
            </div>
        </div>
    );

};

MultipleSearchCriteria.propTypes = {
    pinPlateDetails: PropTypes.object.isRequired,
    label: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

export default MultipleSearchCriteria;
